document.addEventListener("DOMContentLoaded", function(event) {

  // setTimeout(function(){
  //   const sizeInputs = document.querySelectorAll('[data-option-name="Size"] input');
  //   const onLoadVariant = 'Medium';
    
  //   for (const sizeInput of sizeInputs) {
  //     var onLoadVariantVal = sizeInput.value;
      
  //     if (onLoadVariant.match(onLoadVariantVal)) {
  //       console.log(sizeInput.nextElementSibling.classList);
  //       if(sizeInput.nextElementSibling.classList.contains('is-disabled')) {
  //        console.log("medium out of stock")
  //       } else {
  //         console.log("medium in stock")
  //         sizeInput.nextElementSibling.click();
  //       }
  //     }
  //   }
  // }, 400);

  let urlOptionParams = new URLSearchParams(window.location.search);
  let selectedSize = urlOptionParams.get('Size');
  let selectedColor = urlOptionParams.get('Color');
  if (selectedSize && selectedColor) {
    document.querySelectorAll('[data-block-type="product-siblings"] a').forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-color-' + selectedSize + '-' + selectedColor);
      link.href = current + '?variant=' + varId + '&Size=' + selectedSize + '&Color=' + selectedColor;
    });
  } 
  

  function getPrevSiblingBlock(element) {
  while ((element = element.previousSibling)) {
      if (element.style.display === '' && !element.hasAttribute('hidden')) {
        return element;
      }
    }
    return null;
  }

  function getNextSiblingBlock(element) {
  while ((element = element.nextSibling)) {
      if (element.style.display === '' && !element.hasAttribute('hidden')) {
        return element;
      }
    }
    return null;
  }

  const thumbnailMobileControlNext = document.getElementById('thumbnail-mobile-control-next');
  if (thumbnailMobileControlNext !== null) {
    thumbnailMobileControlNext.addEventListener('click', function() {
      const element = document.querySelector('product-gallery-navigation button[aria-current="true"]');
      const nextSibling = getNextSiblingBlock(element);
      
      if (nextSibling) {
        let mediaId = nextSibling.getAttribute('data-media-id');
        if (mediaId !== null) {
          document.querySelector('button[data-media-id="'+ mediaId +'"]').click();
        }
      }
    });
  }

  const thumbnailMobileControlPrev = document.getElementById('thumbnail-mobile-control-prev');
  if (thumbnailMobileControlPrev !== null) {
    thumbnailMobileControlPrev.addEventListener('click', function() {
      const element = document.querySelector('product-gallery-navigation button[aria-current="true"]');
      const nextSibling = getPrevSiblingBlock(element);
      
      if (nextSibling) {
        let mediaId = nextSibling.getAttribute('data-media-id');
        if (mediaId !== null) {
          document.querySelector('button[data-media-id="'+ mediaId +'"]').click();
        }
      }
    });
  }

  let carouselContainer = document.querySelector('.product-gallery .product-gallery__carousel');
  if (carouselContainer !== null) {
    let carouselContainerHeight = carouselContainer.clientHeight;
    document.querySelector('.product-gallery .product-gallery__thumbnail-scroller').style.maxHeight = carouselContainerHeight + 'px';
  }
  

  let readMoreToggle = document.querySelector('.read-more .read-more-toggle');
  let readMoreText = document.querySelector('.read-more .read-more-text');

  if (readMoreToggle !== null) {
    readMoreToggle.addEventListener('click', function() {
      if (readMoreText.style.display === "none") {
        readMoreText.style.display = "block";
        readMoreToggle.innerText = "Read Less";
      } else {
        readMoreText.style.display = "none";
        readMoreToggle.innerText = "Read More";
      }
    }, false);
  }

  var colorSwatch = document.querySelectorAll('variant-picker label.color-swatch');

  for (var i = 0; i < colorSwatch.length; i++) {
    colorSwatch[i].addEventListener('click', function(event) {
      setTimeout(function(){
        const elements = document.querySelectorAll(".product-gallery__thumbnail");
        var elementsArray = Array.from(elements);
        
        // Filter out elements with the hidden attribute
        const visibleElements = elementsArray.filter(element => element.hidden);
        
        // Do something with the visible elements
        visibleElements.forEach(element => {
          element.setAttribute('aria-current', 'false')
        });
      }, 200);
      
    });
  }

  const productCardShowMoreButtons = document.querySelectorAll('.product-card .product-card__colors .show-more');
  
  if (productCardShowMoreButtons) {
      productCardShowMoreButtons.forEach(productCardShowMoreButton => {
      productCardShowMoreButton.addEventListener('click', function() {
        this.remove();
      });
    });
  }

  const productCardColors = document.querySelectorAll('.product-card .product-card__colors label');
  
  if (productCardColors) {
      productCardColors.forEach(productCardColor => {
      productCardColor.addEventListener('click', function() {
        let quickViewColor = this.getAttribute('on-click');
        let quickViewColorName = this.querySelector('span').innerText;
        document.querySelector('[for="' + quickViewColor + '"]').click();
        let quickViewProductCard = this.closest('.product-card');
        quickViewProductCard.querySelector('.product-card__quick-view--mobile-color').innerText = quickViewColorName;
        let unselectedFieldset = quickViewProductCard.querySelector('fieldset[unselected-option]');
        if (unselectedFieldset) {
          unselectedFieldset.removeAttribute('unselected-option');
        }
      });
    });
  }

  const productCardSizes = document.querySelectorAll('.product-card__quick-view [data-option-name="Size"] label, .product-card__quick-view [data-option-name="Options"] label, .product-card__quick-view [data-option-name="Value"] label');
  
    if (productCardSizes) {
        productCardSizes.forEach(productCardSize => {
        productCardSize.addEventListener('click', function() {
          let quickViewContainer = this.closest('.product-card__quick-view');
          setTimeout(function(){
            let variant_id = quickViewContainer.querySelector('input[name="id"]').value;
            // console.log(variant_id);
            var data = {
              "id": variant_id,
              "quantity": 1
            }
            /*jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,  //this code is for prestige theme, is to refresh the cart
                  detail: {
                    quantity: 1
                  }
                }))
                document.querySelector('[aria-controls="cart-drawer"]').click();
              }   
            });*/
          ;(function(){var params=new URLSearchParams();Object.keys(data).forEach(function(key){params.append(key,data[key])});fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:params.toString()}).then(function(response){if(!response.ok)throw new Error("Add to cart failed");return response.json()}).then(function(){document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0,detail:{quantity:1}})),document.querySelector('[aria-controls="cart-drawer"]').click()}).catch(function(err){console.error("Quick add failed:",err)})})();
          }, 50);
          document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.documentElement.classList.remove('lock');
        });
      });
    }

  const productCardQuickDesktopButtons = document.querySelectorAll('.product-card__quick-view .product-card__quick-view--add-desktop');

  if (productCardQuickDesktopButtons) {
      productCardQuickDesktopButtons.forEach(productCardQuickDesktopButton => {
      productCardQuickDesktopButton.addEventListener('click', function() {
        let quickViewContainer = this.closest('.product-card__quick-view');
        document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
          elem.classList.remove('active');
        });
        quickViewContainer.querySelector('.variant-picker').classList.add('active');
      });
    });
  }

  const productCardQuickMobileButtons = document.querySelectorAll('.product-card__quick-view--add-mobile');

  if (productCardQuickMobileButtons) {
      productCardQuickMobileButtons.forEach(productCardQuickMobileButton => {
      productCardQuickMobileButton.addEventListener('click', function() {
        let quickViewProductCard = this.closest('.product-card');
        document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
          elem.classList.remove('active');
        });
        quickViewProductCard.querySelector('.product-card__quick-view').classList.add('active');
        document.documentElement.classList.add('lock');
      });
    });
  }

  const productCardQuickOverlays = document.querySelectorAll('.product-card__quick-view-overlay');

  if (productCardQuickOverlays) {
      productCardQuickOverlays.forEach(productCardQuickOverlay => {
      productCardQuickOverlay.addEventListener('click', function() {
        let quickViewProductCard = this.closest('.product-card');
        quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
        document.documentElement.classList.remove('lock');
      });
    });
  }

  const productCardQuickCloseButtons = document.querySelectorAll('.product-card__quick-view__close-button');

  if (productCardQuickCloseButtons) {
      productCardQuickCloseButtons.forEach(productCardQuickCloseButton => {
      productCardQuickCloseButton.addEventListener('click', function() {
        let quickViewProductCard = this.closest('.product-card');
        quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
        document.documentElement.classList.remove('lock');
      });
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  const campaignIdFromUrl = urlParams.get('BFCM25_holidaysavings');
  console.log(urlParams);

  if (campaignIdFromUrl == 'ALL') {
    let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
    let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

    if (campaignMessages) {
      campaignMessages.forEach(campaignMessage => {
        campaignMessage.style.display = 'block';
      });
    }
    if (campaignPrices) {
      campaignPrices.forEach(campaignPrice => {
        campaignPrice.style.display = 'block';
      });
    }

    localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

    const attributeName = "BFCM25_holidaysavings";
    const attributeValue = "ALL";

    const formData = new FormData();
    formData.append(`attributes[${attributeName}]`, attributeValue);

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated successfully:', data);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });

    setTimeout(function() {
      let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
      let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

      if (campaignMessages) {
        campaignMessages.forEach(campaignMessage => {
          campaignMessage.style.display = 'block';
        });
      }
      if (campaignPrices) {
        campaignPrices.forEach(campaignPrice => {
          campaignPrice.style.display = 'block';
        });
      }

      localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

      const attributeName = "BFCM25_holidaysavings";
      const attributeValue = "ALL";

      const formData = new FormData();
      formData.append(`attributes[${attributeName}]`, attributeValue);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated successfully:', data);
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }, 1000);

    setTimeout(function() {
      let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
      let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

      if (campaignMessages) {
        campaignMessages.forEach(campaignMessage => {
          campaignMessage.style.display = 'block';
        });
      }
      if (campaignPrices) {
        campaignPrices.forEach(campaignPrice => {
          campaignPrice.style.display = 'block';
        });
      }

      localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

      const attributeName = "BFCM25_holidaysavings";
      const attributeValue = "ALL";

      const formData = new FormData();
      formData.append(`attributes[${attributeName}]`, attributeValue);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated successfully:', data);
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }, 2000);

    setTimeout(function() {
      let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
      let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

      if (campaignMessages) {
        campaignMessages.forEach(campaignMessage => {
          campaignMessage.style.display = 'block';
        });
      }
      if (campaignPrices) {
        campaignPrices.forEach(campaignPrice => {
          campaignPrice.style.display = 'block';
        });
      }

      localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

      const attributeName = "BFCM25_holidaysavings";
      const attributeValue = "ALL";

      const formData = new FormData();
      formData.append(`attributes[${attributeName}]`, attributeValue);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated successfully:', data);
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }, 3000);
  }
  
});

document.addEventListener("facet:update",function(event) {
  
  setTimeout(function(){
    const productCardColors = document.querySelectorAll('.product-card .product-card__colors label');
  
    if (productCardColors) {
        productCardColors.forEach(productCardColor => {
        productCardColor.addEventListener('click', function() {
          let quickViewColor = this.getAttribute('on-click');
          let quickViewColorName = this.querySelector('span').innerText;
          document.querySelector('[for="' + quickViewColor + '"]').click();
          let quickViewProductCard = this.closest('.product-card');
          quickViewProductCard.querySelector('.product-card__quick-view--mobile-color').innerText = quickViewColorName;
        });
      });
    }
  
    const productCardSizes = document.querySelectorAll('.product-card__quick-view [data-option-name="Size"] label, .product-card__quick-view [data-option-name="Options"] label, .product-card__quick-view [data-option-name="Value"] label');
  
    if (productCardSizes) {
        productCardSizes.forEach(productCardSize => {
        productCardSize.addEventListener('click', function() {
          let quickViewContainer = this.closest('.product-card__quick-view');
          setTimeout(function(){
            let variant_id = quickViewContainer.querySelector('input[name="id"]').value;
            // console.log(variant_id);
            var data = {
              "id": variant_id,
              "quantity": 1
            }
            /*jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,  //this code is for prestige theme, is to refresh the cart
                  detail: {
                    quantity: 1
                  }
                }));
              }   
            })*/;(function(){var params=new URLSearchParams();Object.keys(data).forEach(function(key){params.append(key,data[key])});fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:params.toString()}).then(function(response){if(!response.ok)throw new Error("Add to cart failed");return response.json()}).then(function(){document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0,detail:{quantity:1}}))}).catch(function(err){console.error("Quick add failed:",err)})})(); 
          }, 50);
          document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.documentElement.classList.remove('lock');
        });
      });
    }

    const productCardQuickDesktopButtons = document.querySelectorAll('.product-card__quick-view .product-card__quick-view--add-desktop');

    if (productCardQuickDesktopButtons) {
        productCardQuickDesktopButtons.forEach(productCardQuickDesktopButton => {
        productCardQuickDesktopButton.addEventListener('click', function() {
          let quickViewContainer = this.closest('.product-card__quick-view');
          document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
            elem.classList.remove('active');
          });
          quickViewContainer.querySelector('.variant-picker').classList.add('active');
        });
      });
    }
  
    const productCardQuickMobileButtons = document.querySelectorAll('.product-card__quick-view--add-mobile');
  
    if (productCardQuickMobileButtons) {
        productCardQuickMobileButtons.forEach(productCardQuickMobileButton => {
        productCardQuickMobileButton.addEventListener('click', function() {
          let quickViewProductCard = this.closest('.product-card');
          document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
            elem.classList.remove('active');
          });
          quickViewProductCard.querySelector('.product-card__quick-view').classList.add('active');
          document.documentElement.classList.add('lock');
        });
      });
    }
  
    const productCardQuickOverlays = document.querySelectorAll('.product-card__quick-view-overlay');
  
    if (productCardQuickOverlays) {
        productCardQuickOverlays.forEach(productCardQuickOverlay => {
        productCardQuickOverlay.addEventListener('click', function() {
          let quickViewProductCard = this.closest('.product-card');
          quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
          document.documentElement.classList.remove('lock');
        });
      });
    }

    const productCardQuickCloseButtons = document.querySelectorAll('.product-card__quick-view__close-button');

    if (productCardQuickCloseButtons) {
        productCardQuickCloseButtons.forEach(productCardQuickCloseButton => {
        productCardQuickCloseButton.addEventListener('click', function() {
          let quickViewProductCard = this.closest('.product-card');
          quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
          document.documentElement.classList.remove('lock');
        });
      });
    }
  }, 1000);
  
});

document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  if (variant.available) {
    document.querySelector('.sold-out-label').style.display = "none";
  } else {
    document.querySelector('.sold-out-label').style.display = "block";
  }

  let selectedColor = variant.option1.replace(/\s/g, "").toLowerCase();
  let selectedSize = variant.option2.replace(/\s/g, "").toLowerCase();
  document.querySelectorAll('[data-block-type="product-siblings"] a').forEach(link => {
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-color-' + selectedSize + '-' + selectedColor);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize + '&Color=' + selectedColor;
  });

  if (variant.id == 39888071229525) {
    console.log('true');
    let laundryVariantPriceList = document.querySelector('price-list[variant-price="39888071229525"]');
    if (laundryVariantPriceList) {
      laundryVariantPriceList.style.display = 'flex';
    }
  } else {
    let laundryVariantPriceList = document.querySelector('price-list[variant-price="39888071229525"]');
    if (laundryVariantPriceList) {
      laundryVariantPriceList.style.display = 'none';
    }
  }
});


const urlParams = new URLSearchParams(window.location.search);
const campaignIdFromUrl = urlParams.get('BFCM25_holidaysavings');
console.log(urlParams);

if (campaignIdFromUrl == 'ALL') {
  localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

  const attributeName = "BFCM25_holidaysavings";
  const attributeValue = "ALL";

  const formData = new FormData();
  formData.append(`attributes[${attributeName}]`, attributeValue);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart updated successfully:', data);
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

(function () {
  const CONTAINER_ID = 'freegifts-main-popup-container';
  const OFFER_IDS = ['90761','174721', '176356', '176360']; // Add or remove offer IDs here
  const OFFER_SELECTOR = OFFER_IDS.map(id => `[data-offer="${id}"]`).join(', ');
  const TITLE_SELECTOR = '.fg-section-title';
  const SUBTITLE_CLASS = '.fg-section-subtitle';
  const SUBTITLE_HTML = '<div class="fg-section-subtitle">This Mother\'s Day, every order over $75<br> comes with a complimentary gift.</div>';

  function injectSubtitle(popup) {
    if (popup.querySelector(SUBTITLE_CLASS)) return;
    const titleEl = popup.querySelector(TITLE_SELECTOR);
    if (titleEl) {
      titleEl.insertAdjacentHTML('afterend', SUBTITLE_HTML);
    }
  }

  function checkPopup(popup) {
    if (popup.querySelector(OFFER_SELECTOR)) {
      injectSubtitle(popup);
    }
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        // Case 1: The container itself was just added
        if (node.id === CONTAINER_ID) {
          checkPopup(node);
          continue;
        }

        // Case 2: Something was added inside the container
        const popup = node.closest('#' + CONTAINER_ID) ?? node.querySelector('#' + CONTAINER_ID);
        if (popup) {
          checkPopup(popup);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/* ---------------------------------------------------------------------------
 * VARIANT IMAGE SET — client-side re-filter
 *
 * Why this exists:
 * The gallery's variant image filtering is done in Liquid (snippets/product-
 * gallery.liquid), which only runs on page load. Clicking a colour swatch
 * updates the DOM without a reload, so the Liquid never re-runs and the
 * gallery stays frozen on whatever rendered initially.
 *
 * This mirrors the Liquid logic in JS and re-applies it on every variant
 * change, so the gallery follows the swatch.
 *
 * Registered as its OWN listener on purpose — the existing variant:change
 * handler in custom.js can throw before it finishes, and a throw in one
 * listener must not take this one down with it.
 *
 * Append to the end of assets/custom.js.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  // Media id of whatever rendered as the initial slide. Used as a fallback
  // "default media" so untagged images don't all vanish when a variant has no
  // featured media of its own — matches the Liquid `| default: product.featured_media`.
  var fallbackDefaultMediaId = null;

  document.addEventListener('DOMContentLoaded', function () {
    var initial = document.querySelector('.product-gallery__media.is-initial');
    if (initial) {
      fallbackDefaultMediaId = initial.getAttribute('data-media-id');
    }
  });

  /**
   * Parse an alt string of the form "#color_Cherry Vanilla".
   * Returns { option: 'color', value: 'cherry vanilla' } or null if untagged.
   * Mirrors: alt | split: '#' | last | split: '_'
   */
  function parseAltGroup(alt) {
    if (!alt || alt.indexOf('#') === -1) return null;

    var tail = alt.split('#').pop();
    var parts = tail.split('_');
    if (parts.length < 2) return null;

    return {
      option: parts[0].trim().toLowerCase(),
      // Re-join in case a colour name itself contains an underscore.
      value: parts.slice(1).join('_').trim().toLowerCase()
    };
  }

  function altFor(el) {
    var img = el.querySelector('img');
    return img ? img.getAttribute('alt') : null;
  }

  /**
   * Build { optionNameLowercased: selectedValueLowercased } for the variant.
   * Option names are read from the variant picker so this doesn't hardcode
   * "option1 is Colour" — if a product ever orders its options differently,
   * this still lines up.
   */
  function selectedOptions(variant) {
    var names = [];

    document
      .querySelectorAll('variant-picker [data-option-name]')
      .forEach(function (el) {
        var name = el.getAttribute('data-option-name');
        if (name && names.indexOf(name) === -1) names.push(name);
      });

    if (!names.length) names = ['Color', 'Size'];

    var map = {};
    names.forEach(function (name, i) {
      var value = variant['option' + (i + 1)];
      if (value) map[name.trim().toLowerCase()] = String(value).trim().toLowerCase();
    });

    return map;
  }

  function filterGallery(variant) {
    var gallery = document.querySelector('product-gallery');
    if (!gallery || !variant) return;

    var selected = selectedOptions(variant);

    var defaultMediaId =
      (variant.featured_media && String(variant.featured_media.id)) ||
      fallbackDefaultMediaId;

    // media id -> hidden?  Reused so thumbnails stay in sync with slides.
    var hiddenById = {};

    gallery.querySelectorAll('.product-gallery__media').forEach(function (el) {
      var id = el.getAttribute('data-media-id');
      var group = parseAltGroup(altFor(el));
      var isDefault = id && id === defaultMediaId;
      var hide;

      if (!group || !(group.option in selected)) {
        // Untagged, or tagged against an option this product doesn't have.
        // Liquid hides these for every variant except the default.
        hide = !isDefault;
      } else {
        hide = selected[group.option] !== group.value && !isDefault;
      }

      hiddenById[id] = hide;
      el.toggleAttribute('hidden', hide);

      // Clear any stale inline display left by other scripts.
      if (!hide && el.style.display === 'none') el.style.removeProperty('display');
    });

    gallery.querySelectorAll('.product-gallery__thumbnail').forEach(function (btn) {
      var id = btn.getAttribute('data-media-id');
      if (!(id in hiddenById)) return;

      btn.toggleAttribute('hidden', hiddenById[id]);

      // A hidden thumbnail must never stay flagged as the current one.
      if (hiddenById[id]) btn.setAttribute('aria-current', 'false');
    });

    // Bring the first surviving slide into view, and mark its thumbnail current.
    var firstVisible = gallery.querySelector('.product-gallery__media:not([hidden])');
    if (firstVisible) {
      if (typeof firstVisible.scrollIntoView === 'function') {
        firstVisible.scrollIntoView({ block: 'nearest', inline: 'start' });
      }

      var firstId = firstVisible.getAttribute('data-media-id');
      var firstThumb = gallery.querySelector(
        '.product-gallery__thumbnail[data-media-id="' + firstId + '"]'
      );
      if (firstThumb) {
        gallery.querySelectorAll('.product-gallery__thumbnail[aria-current="true"]')
          .forEach(function (el) { el.setAttribute('aria-current', 'false'); });
        firstThumb.setAttribute('aria-current', 'true');
      }
    }
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    // Defer one tick so Prestige finishes its own DOM updates first,
    // otherwise it can overwrite these attributes immediately after.
    setTimeout(function () {
      try {
        filterGallery(variant);
      } catch (err) {
        console.error('[ONDO] gallery variant filter failed:', err);
      }
    }, 0);
  });
})();